/** @module store/admin/users_management */

// TODO: is deprecated and can be removed, or?
import { getUsers as apiGetUsers } from '@/api/users'

// WIP: currently only a dummy
const state = () => ({
  users: []
})

const getters = {
  getUser: (state) => {
    return (userId) => {
      // eslint-disable-next-line eqeqeq
      return state.users.find((u) => u.id == userId)
    }
  }
}

const mutations = {
  SET_USERS: (state, users) => {
    state.users = users
  },
  SET_USER: (state, user) => {
    // eslint-disable-next-line eqeqeq
    const i = state.users.findIndex((u) => u.id == user.id)
    if (i < 0) {
      state.users.push(user)
    } else {
      state.users.splice(i, 1, user)
    }
  }
}

/**
 * Action to perform a GET users API call
 *
 * @function
 *
 * @return {promise}
 */
function getUsers({ commit }) {
  return apiGetUsers({ sort: 'email' }).then((res) => {
    const users = res.payload.data
    commit('SET_USERS', users)

    return users
  })
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    getUsers
  }
}
